import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

require('exports-loader?jwplayer!libs/jwplayer/jwplayer');
require('libs/jwplayer/jwplayer.html5');


// Simplify video loading. Use snippets/video-tag.html to load the html and
// require this file to automatically wrap it with jwplayer.
// If you need to set up a jwplayer video at runtime, use this:
//    new Video({el: video_element});
// Make sure the element has a unique id
const Video = Backbone.View.extend({
  initialize: function () {
    _.bindAll(this, 'resize_player');
    this.video_wrap = this.$el.parents('.home-video');
    this.original_width = this.$el.data('width');
    this.original_height = this.$el.data('height');
    // now compare
    this.actual_width = this.original_width;
    if (this.video_wrap.width()) {
      this.actual_width = this.video_wrap.width() / this.original_width * this.original_width;
    }
    this.aspect_ratio = Number(this.original_width / this.original_height).toPrecision(4);
    jwplayer.key = 'rvepTMYFZvO0TwPNoWeTw8gZtMsEDcfsIDHn+srQCcs=';

    this.player = jwplayer(this.$el.attr('id')).setup({
      id: this.$el.data('id'),
      skin: 'bekle',
      width: this.actual_width,
      height: this.actual_width * this.aspect_ratio,
      file: this.$el.data('file'),
      image: this.$el.data('image'),
      flashplayer: this.$el.data('swf'),
      fallback: 'flash'
    });

    this.player.onReady(this.resize_player);
    $(window).resize(this.resize_player);
  },

  resize_player: function () {

    var new_video_width = this.actual_width;
    // exercise view has two video and can't get container width, since first child is hidden
    var containerWidth = this.video_wrap.width();

    if (containerWidth) {
      this.actual_width = new_video_width = containerWidth / this.original_width * this.original_width;
    }
    this.player.resize(new_video_width, Math.round(new_video_width / this.aspect_ratio));
  }
});

  // Initialize any videos on the page
_.each($('.video-embed'), function (video_embed) {
  new Video({ el: video_embed });
});


module.exports = Video;



// WEBPACK FOOTER //
// ./static/js/views/video.js